import React from 'react';
import {Route} from 'react-router';

import AssignmentsTabContent from './Assignments/Assignments';
import {clearSkillPathCache} from './SkillPath/hooks/useStudentSkillPath';
import {IndependentPractice as IndependentPracticeTabContent} from './IndependentPractice/IndependentPractice';
import {getFeatureFlagStatus} from 'client/components/FeatureFlag/featureFlag.utils';
import sessionStore from 'client/Session/SessionStore';
import {SkillPath as SkillPathTabContent} from './SkillPath/SkillPath';
import StudentHomepage from './StudentHomepage';
import TeacherDashboardGate from 'client/TeacherDashboard/TeacherDashboardGate';
import WelcomeComponent from './Welcome';

export {Routes} from './routes.constants';

const StudentHomepageRoutes = (
  <Route
    getComponent={(_nextState, cb) => {
      cb(null, sessionStore.isStudent() ? StudentHomepage : TeacherDashboardGate);
    }}
    onEnter={(_nextState, replace, callback) => {
      if (!sessionStore.hasValidSession()) {
        replace('/log-in');
      } else if (!sessionStore.isStudent() && !sessionStore.isTeacher()) {
        replace('/classes');
      } else if (!sessionStore.isStudent()) {
        // Redirect flag-off teachers in-transition so /home never flashes for them.
        getFeatureFlagStatus('teacher_dashboard_v2').then((isEnabled) => {
          if (!isEnabled) {
            replace('/classes');
          }
          callback?.();
        });
        return;
      }
      callback?.();
    }}
    onLeave={() => {
      clearSkillPathCache();
    }}
    path='home'
  >
    <Route component={AssignmentsTabContent} path='(class/:classroomId/)assignments' />
    <Route
      component={IndependentPracticeTabContent}
      path='(class/:classroomId/)independent-practice'
    />
    <Route component={SkillPathTabContent} path='(class/:classroomId/)skill-path' />
    <Route component={WelcomeComponent} path='welcome' />
  </Route>
);

export default StudentHomepageRoutes;
